// src/api/axios.js

import axios from 'axios';
import { expirePortalSession, isPortalLogoutInProgress } from './portalSession';
import { getItem } from './localStorageUtil';
import { LOCAL_STORAGE_KEYS } from '../const/localStorageConst';
// import proxy from '../setupProxy'
/**
 * 获取基础URL
 * - 开发环境: 使用环境变量中配置的URL
 * - 生产环境: 使用当前域名
 */
const getBaseUrl = () => {
  return "http://127.0.0.1:7010"
// return ""
};

// 创建axios实例
const instance = axios.create({
//   baseURL: getBaseUrl(),
  timeout: 600000,
  headers: {
    'Content-Type': 'application/json'
  }
});


// 请求拦截器
instance.interceptors.request.use(
  config => {
    // console.log("------请求拦截",config)
    // 在发送请求前做些什么
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = token
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// proxy(instance.interceptors.request)
// 响应拦截器
instance.interceptors.response.use(
  response => {
    // Some API routes report authorization failure in the JSON envelope with HTTP 200.
    if (!isPortalLogoutInProgress() && response.data?.status === 403 && response.config?.headers?.token === String(getItem(LOCAL_STORAGE_KEYS.TOKEN))) {
      expirePortalSession();
    }
    return response;
  },
  error => {
    if (error.response) {
      const status = error.response.status;
      console.error('Response error:', status, error.response.data);

      // 403 表示 token 无效或过期，清除本地 token 并跳转到登录页
      if (!isPortalLogoutInProgress() && status === 403 && error.config?.headers?.token === String(getItem(LOCAL_STORAGE_KEYS.TOKEN))) {
        expirePortalSession();
      }
    } else if (error.request) {
      console.error('No response received:', error.request);
    } else {
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default instance;